import { AbstractMap3sqd8xvg0030s as AbstractMap } from './AbstractMap.mjs';
import {
  HashMapKeysDefaultd8xopyn6vbgh as HashMapKeysDefault,
  HashMapValuesDefault3j1xghpfb6bpq as HashMapValuesDefault,
} from './HashMapEntryDefault.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../Unit.mjs';
import { equals2au1ep9vhcato as equals } from '../js/coreRuntime.mjs';
import { KtMutableMap1kqeifoi36kpz as KtMutableMap } from './Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractMutableMapClass;
function AbstractMutableMap() {
  if (AbstractMutableMapClass === VOID) {
    class $ extends AbstractMap() {
      static v7() {
        var $this = this.y7();
        $this.t7_1 = null;
        $this.u7_1 = null;
        return $this;
      }
      z7() {
        return HashMapKeysDefault().b8(this);
      }
      c8() {
        return HashMapValuesDefault().e8(this);
      }
      a5() {
        var tmp0_elvis_lhs = this.t7_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = this.z7();
          this.t7_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      b5() {
        var tmp0_elvis_lhs = this.u7_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = this.c8();
          this.u7_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      f5() {
        this.q3().f5();
      }
      e5(from) {
        this.t6();
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = from.q3().u1();
        while (_iterator__ex2g4s.v1()) {
          var _destruct__k2r9zo = _iterator__ex2g4s.w1();
          // Inline function 'kotlin.collections.component1' call
          var key = _destruct__k2r9zo.r3();
          // Inline function 'kotlin.collections.component2' call
          var value = _destruct__k2r9zo.s3();
          this.c5(key, value);
        }
      }
      d5(key) {
        this.t6();
        var iter = this.q3().u1();
        while (iter.v1()) {
          var entry = iter.w1();
          var k = entry.r3();
          if (equals(key, k)) {
            var value = entry.s3();
            iter.u6();
            return value;
          }
        }
        return null;
      }
      t6() {
      }
    }
    initMetadataForClass($, 'AbstractMutableMap', VOID, VOID, [AbstractMap(), KtMutableMap()]);
    AbstractMutableMapClass = $;
  }
  return AbstractMutableMapClass;
}
//region block: exports
export {
  AbstractMutableMap as AbstractMutableMapyktux9ubhc1g,
};
//endregion

//# sourceMappingURL=AbstractMutableMap.mjs.map
